<template>
  <div>
    <div class="grid">
      <template v-for="(i, k) in items">
        <div :key="'name' + k" class="name">
          {{ i.name }}
        </div>
        <div :key="'diagram' + k" class="d-flex mb-3 mb-md-0">
          <v-card :color="i.color" :width="(Number(i.count) * 100) / highest + '%'" height="30" flat tile class="rel">
            <div class="abs d-flex align-center">
              {{ i.count + ' ' + localStorage.translations.pages.common.measure['piece'] }}
            </div>
          </v-card>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "WidgetHorizontalDiagram",
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  computed: {
    highest() {
      return Math.max.apply(null, this.items.map(data => Number(data.count)));
    },
  }
}
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto;
  grid-gap: 16px;
  padding: 0 70px 0 0;
  align-items: center;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    grid-template-columns: 1fr;
    grid-gap: 4px;
  }
}
.name {
  color: #277FAF;
}
.rel {
  position: relative;
}
.abs {
  position: absolute;
  left: calc(100% + 8px);
  height: 100%;
  white-space: nowrap;
}
</style>
